let goalKey = 0;

export const newGoal = (team, scorerId, assistId) => ({
  key: `g${goalKey++}`,
  team,
  scorerId: scorerId ?? null,
  assistId: assistId ?? null,
});

/**
 * Rebuilds a goal list from the per-player totals stored in the database.
 *
 * Only totals are persisted, so which assist went with which goal is not
 * recoverable — this pairs them up in order, which keeps every total exactly
 * right even though individual pairings are a guess.
 *
 * Assists that cannot be attached to a goal are dropped and counted. Older data
 * can contain more assists than goals (nothing stopped it), but in the current
 * model an assist only exists because a goal was added, so carrying those
 * forward would mean showing a state the app can no longer produce.
 */
export function goalsFromTotals(players) {
  const goals = [];
  let dropped = 0;

  ['A', 'B'].forEach((team) => {
    const squad = players.filter((p) => p.team === team);

    squad.forEach((p) => {
      for (let i = 0; i < (p.goals || 0); i++) goals.push(newGoal(team, p.id, null));
    });

    const slots = goals.filter((g) => g.team === team);
    squad.forEach((p) => {
      for (let i = 0; i < (p.assists || 0); i++) {
        // Never credit someone with assisting their own goal.
        const slot = slots.find((g) => g.assistId === null && g.scorerId !== p.id);
        if (slot) slot.assistId = p.id;
        else dropped++;
      }
    });
  });

  return { goals, dropped };
}
